import { Col, DatePicker, Row, Table } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectSidebarList } from 'components/Common/Sidebar/sidebarSlice';
import { analyticsActions } from 'features/Analysis/analysisSlice';
import AnalysisDetailChart from 'features/Analysis/components/AnalysisDetailChart/AnalysisDetailChart';
import AnalysisInfoChart from 'features/Analysis/components/AnalysisInfoChart/AnalysisInfoChart';
import { customPlant } from 'models';
import moment from 'moment';
import * as React from 'react';
import { formatDataTable } from 'utils/common';
import style from './Analysis.module.scss';
export interface AnalysisProps {}

export default function Analysis(props: AnalysisProps) {
  const dispatch = useAppDispatch();
  const plantList = useAppSelector(selectSidebarList);
  const [selectedRowKeys, setSelectedRowKeys] = React.useState<string[]>([]);
  const [dataTable, setDataTable] = React.useState<customPlant[]>();
  const [date_Filter, setDateFilter] = React.useState<string>(moment().format('YYYY'));

  React.useEffect(() => {
    if (plantList.length !== 0) {
      let newArray: customPlant[] = formatDataTable(plantList);
      setDataTable(newArray);
      setSelectedRowKeys([newArray[0].key]);
    }
  }, [plantList]);

  React.useEffect(() => {
    dispatch(
      analyticsActions.fetchDataOfPlantAnalytics({
        selectedItems: selectedRowKeys,
        times: date_Filter,
      })
    );
  }, [dispatch, selectedRowKeys, date_Filter]);

  const columns = [
    {
      key: 'label',
      title: 'Name',
      dataIndex: 'label',
      width: '100%',
      ellipsis: true,
    },
  ];

  const onSelectChange = (selectedRowKeys: any) => {
    setSelectedRowKeys(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <Row className={style.root}>
      <Col span={8} className={style.table}>
        <Row className={style.detail_table}>
          <Row className={style.header_table}>PLANT LIST</Row>
          <Row className={style.container_table}>
            <Table
              rowSelection={{ ...rowSelection }}
              columns={columns}
              dataSource={dataTable}
              pagination={false}
              // scroll={{ y: 'calc(100vh - 280px)' }}
            />
          </Row>
        </Row>
      </Col>
      <Col span={16} className={style.chart}>
        <Row className={style.header_chart}>
          <Row className={style.label_chart}>PRODUCTIVITY EFFICIENCY</Row>
          <Row className={style.total_alarm}>
            <DatePicker
              picker="year"
              defaultValue={moment(date_Filter)}
              onChange={(value) => {
                setDateFilter(moment(value).format('YYYY'));
              }}
              style={{ backgroundColor: '#4fd20f', border: 'true' }}
            />
          </Row>
        </Row>
        <Row className={style.container_chart}>
          <Row className={style.one_chart}>
            <AnalysisInfoChart />
          </Row>
          <Row className={style.two_chart}>
            <AnalysisDetailChart />
          </Row>
        </Row>
      </Col>
    </Row>
  );
}
